<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        border
        stripe
        ref="table"
        :loading="loading"
        :columns="columns"
        :data="data"
        highlight-row
        @on-row-click="rowClick"
      >
      </Table>
        <div style="display: flex;justify-content: space-between;margin-top: 15px;">
          <Page :total="total" @on-change="pageChange"></Page>
          <div>
            <Button v-if="plan ? false : true" style="margin-left:15px" @click="addRow">新增</Button>
          </div>
        </div>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title"></p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="150"
        inline
        label-position="left"
        :disabled="plan ? true : false"
        v-if="showSelfData.SkillInformation == '1'"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="val"
          style="margin-right: 50px;"
          v-if="showSelfData[val] == '1'"
        >
          <DatePicker
            v-if="val == 'qualifydate' || val == 'expiredate'"
            type="date"
            v-model="formItem[val]"
            style="min-width: 260px"
            :disabled="formItem.flag != '1'"
          ></DatePicker>
          <Select
            v-else-if="val == 'skillcode' || val == 'degreecode'"
            :clearable="true"
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="formItem.flag == '0' || plan ? true : false"
          >
            <Option
              v-for="item in val == 'skillcode' && formItem.flag == '0' ? skillList :  val == 'skillcode' && formItem.flag == '1' ? Language : skillLevelList"
              :value="item.code"
              :key="item.code"
              :label="item.ch_value"
            ></Option>
          </Select>
          <Checkbox
            v-else-if="val == 'certificate'"
            v-model="formItem[val]"
            :disabled="formItem.flag != '1'"
          ></Checkbox>
          <Input
            v-else-if="val == 'comment'"
            type="textarea"
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="formItem.flag != '1'"
          />
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="formItem.flag != '1'"
          />
        </FormItem>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button
        type="primary"
        @click="saveData()"
        v-if="plan ? false : true"
        :disabled="formItem.flag != '1'"
        >保存</Button
      >
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../../src/util/DateUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      date: new DateUtil(),
      formItem: {
        certificate: 0
      },
      data: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 1,
      loading: false,
      certificate: "",
      disableSelfData: {},
      showSelfData: {},
      skillList: [],
      Language:[],
      skillLevelList: [],
      chNameMap: {},
      enNameMap: {},
      id: null,
      plan: null,
      userId: "",
      sortfMap: {}
    };
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    columns() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.qualifydate
              : this.enNameMap.qualifydate,
          key: "qualifydate",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.qualifydate, "YYYY/MM/DD")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.skillcode
              : this.enNameMap.skillcode,
          key: "skillcode",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            if(params.row.flag=='0'){
              return h(
              "span",
              this.skillList
                .filter(item => item.code == params.row.skillcode)
                .map(res => res.ch_value)
              )
            }else{
              return h(
              "span",
              this.Language
                .filter(item => item.code == params.row.skillcode)
                .map(res => res.ch_value)
              )
            }
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.skillscore
              : this.enNameMap.skillscore,
          key: "skillscore",
          align: "center",
          minWidth: 160
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.degreecode
              : this.enNameMap.degreecode,
          key: "degreecode",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.skillLevelList
                .filter(item => item.code == params.row.degreecode)
                .map(res => res.ch_value)
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.validityperiod
              : this.enNameMap.validityperiod,
          key: "validityperiod",
          align: "center",
          minWidth: 160
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.expiredate
              : this.enNameMap.expiredate,
          key: "expiredate",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.expiredate, "YYYY/MM/DD")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.certificatenumber
              : this.enNameMap.certificatenumber,
          key: "certificatenumber",
          align: "center",
          minWidth: 160
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.comment : this.enNameMap.comment,
          key: "comment",
          align: "center",
          minWidth: 160
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.certificate
              : this.enNameMap.certificate,
          key: "certificate",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            let certificate1 = params.row.certificate;
            if (certificate1 == 1) {
              certificate1 = "是";
            } else {
              certificate1 = "否";
            }
            return h("span", certificate1);
          }
        }
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  methods: {
    getData(id, plan) {
      this.plan = plan ? plan : "";
      this.id = id;
      this.getTableData();
    },
    getTableData() {
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1",
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      this.loading = true;
      axios.post("/UserSkill/researchUserSkillInfo", obj).then(res => {
        this.loading = false;
        if (res) {
          this.data = res.data;
          this.total = Number(res.pageInfo.total);
          this.showSelfData = res.showSelfData;
          this.disableSelfData = res.disableSelfData;
          this.chNameMap = res.chNameMap;
          this.enNameMap = res.enNameMap;
          this.sortfMap = res.sortfMap;
          delete this.sortfMap[10];
          this.disableSelfData.SkillInformation =
            this.disableSelfData.SkillInformation == 0 ? true : false;
          this.skillList = res.optionData.SKILL;
          this.skillLevelList = res.optionData.SKILLLEVEL;
          this.Language = res.optionData.Language;
        }
      });
    },
    addRow(){
        // 点击新增时 将技能下拉框只存放一个语言类.
        this.formItem={},
        this.formItem.flag = '1'
        this.formItem.serialnumber = this.userId
        this.formItem.skillcode = 'S11'
        this.$forceUpdate()
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getTableData();
    },
    rowClick(row, index) {
      this.formItem = row;
      this.formItem.certificate = !!+this.formItem.certificate;
    },
    saveData() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          let obj = {
            serialnumber: this.plan,
            ...this.formItem,
            certificate: (this.certificate =
              this.formItem.certificate == true ? 1 : 0)
          };
          axios.post("/UserSkill/insertUserSkillInfo", obj).then(res => {
            if (res) {
              this.getTableData();
              this.$Message.info(res);
              this.formItem = {};
            }
          });
        },
        onCancel: () => {}
      });
    },
    returnPage() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/SkillInformation.vue